export default __webpack_public_path__ + "static/media/stx.7b6b38ee.png";